<div>
  <div *ngIf="steps" class="step-wrapper">
    <div class="step-wrap">

      <span *ngFor="let step of steps; let i = index; let isLast = last; let isFirst = first" class="step">

        <!--[style.flex]="isLast ? (i + 1) * 2 : i + 1"-->
        <!--[class.subHeader]="pid" -->

        <i class="material-icons breadcrumb" [ngStyle]="{'margin-left': (isFirst) ? '-7px' : '0'}"><span
            *ngIf="!isFirst">keyboard_arrow_left</span><span *ngIf="isFirst">&nbsp;</span></i>
        <a (click)="goToStep(step.ref)" class="step-name">
          <span *ngFor="let n of step.name">{{ n ? translate.instant(n) : n}}</span>
        </a>

      </span>

      <span *ngIf="module" class="step">
        <i class="material-icons breadcrumb"><span>keyboard_arrow_left</span></i>
        <a class="step-name"><span *ngIf="module.tabindex == 0">{{translate.instant('DATA.DOCUMENTEN')}}</span>
          <span *ngIf="module.tabindex == 1">{{translate.instant('DATA.SUBPIDS')}}</span>
        </a>
      </span>


    </div>


    <div *ngIf="pid" class="pid-toolbar-info">
      <div>
        <div class="pid-toolbar-desc">
          <h1>{{pid.name}}</h1>
          <div class="highlight">{{pid.address.address}} | {{pid.address.zip}}
            {{pid.address.city}}</div><br />
          <!--<span style="color: black !important" class="highlight">{{ pid.construction | date: 'dd/MM/yyyy'}}
          ({{translate.instant('DATA.CONSTRUCTION_DATE')}})</span><br />
        <span>{{pid.client}}</span><br />-->
        </div>

        <!-- && pid.children.display.length > 0 -->
        <button (click)="module.updateTabIndex(1);" *ngIf="module && !pid.parentPID" class="units-pidinfo first"
          [ngClass]="{'active': module.tabindex==1}">{{translate.instant('DATA.SUBPIDS')}}
          ({{pid.children.display.length}})</button>

        <button (click)="module.updateTabIndex(0)" *ngIf="module" class="documents-pidinfo"
          [ngClass]="{'active': module.tabindex==0}">{{translate.instant('DATA.DOCUMENTEN')}}
          ({{module.files.all.length + module.pending.all.length}})</button>



      </div>

      <div class="pid-toolbar-completion">

        <div style="float:right">
          <div *ngIf="module && module.tabindex == 0"><span
              *ngIf="!isPhone">{{translate.instant('PID_CARD.PID_COMPLETION')}} </span><span
              *ngIf="pid.fileTotal">{{pid.fileCompleted}} / {{pid.fileTotal}}</span><span
              *ngIf="!pid.fileTotal">&nbsp;</span></div>
          <mat-progress-bar *ngIf="module && module.tabindex == 0" mode="determinate" [value]="pid.percentage"
            [class.progress-bar-attention]="pid.percentage < 40"
            [class.progress-bar-warning]="pid.percentage >= 40 && pid.percentage < 70"></mat-progress-bar>

          <div style="margin-top: 10px">
            <a class="step-name" (click)="goToAudittrail()" style="float:right">
              <!--text-decoration: underline; text-decoration-thickness: 2px; -->
              {{translate.instant('AUDITTRAIL.AUDITTRAIL2')}}
            </a> <br />
          </div>


          <div *ngIf="pid?.transferTo?.details">
            <div *ngFor="let detail of pid.transferTo.details">
              <div style="float:right; padding-top:10px" *ngIf="detail?.transferPDF?.uploaded">

                <span>
                  <a *ngIf="detail.transferPDF?.pdf && pid.copy && pid._id == detail.PID" href="{{detail.transferPDF.pdf.url}}" style="color: #333">
                    {{translate.instant('PID_CARD.RECEIVED_FROM')}} {{detail.email}}
                  </a>
                  <a *ngIf="detail.transferPDF?.pdf && pid.copy && pid._id != detail.PID" class="step-name" style="color: #333" 
                  href="{{detail.transferPDF.pdf.url}}">
                    {{translate.instant('PID_CARD.TRANSFERRED_TO')}} {{detail.email}}
                </a>
                  <a *ngIf="detail.transferPDF?.pdf && !pid.copy" class="step-name" style="color: #333" 
                    href="{{detail.transferPDF.pdf.url}}">
                    {{translate.instant('PID_CARD.RECEIVED_FROM')}} {{detail.email}}
                  </a>
                  
                </span>
                <!--({{detail.transferPDF.uploaded| date: 'dd/MM/yyyy HH:mm:ss'}})-->
              </div>
            </div>
          </div>


          <div *ngIf="pid?.printall?.uploaded">
            <div style="float: right; padding-top:10px">
              <a *ngIf="pid.printall.pdf" style="color: #333" class="step-name" href="{{pid.printall.pdf.url}}">
                PDF
              </a>

              <a *ngIf="pid.printall.zip" style="color: #333" class="step-name" href="{{pid.printall.zip.url}}">
                ZIP
              </a>
            </div>
            <!--({{pid.printall.uploaded| date: 'dd/MM/yyyy HH:mm:ss'}})-->

          </div>

        </div>


      </div>
    </div>
  </div>